import React, { createContext, useContext, useRef, useState, useEffect, useReducer } from 'react';
import Slider from '@material-ui/core/Slider';
import { withStyles, makeStyles } from '@material-ui/core/styles';

const TEMP = (props) => {
    const { onAnswer, questionIndex, answers } = props;

    const [temp, setTemp] = useState(98.6);
    const [color, setColor] = useState('#28A745');
    // const [icon, setIcon] = useState(faCheck);

    useEffect(() => {
        if (onAnswer) {
            if (answers[questionIndex] && answers[questionIndex].length > 0) {
                console.log("TEMP SET");
            } else {
                onAnswer('98.6', questionIndex);
            }
        }
    }, [onAnswer ? answers[questionIndex] : null])

    useEffect(() => {
        if (temp && onAnswer) {
            onAnswer(JSON.stringify(temp), questionIndex);
        }
    }, [temp])

    const CustomSlider = withStyles({
        root: {
            color: color,
            height: 46,
            width: '46px !important'
        },
        thumb: {
            width: 0,
            height: 0,
            '&:focus, &:hover, &$active': {
                boxShadow: 'none',
              },
        },
        active: {},
        valueLabel: {
            left: -46,
        },
        track: {
            height: 46,
            width: '46px !important',
            borderRadius: 30,
        },
        rail: {
            height: 46,
            width: '46px !important',
            borderRadius: 30,
        },
    })(Slider);

    const getTempColor = (value) => {
        if (value >= 105) {
            setColor('#960002');
            // setIcon(faTemperatureHigh);
        } else if (value >= 103) {
            setColor('#DD1A22');
            // setIcon(faTemperatureHigh);
        } else if (value >= 100.4) {
            setColor('#F67A05');
            // setIcon(faTemperatureHigh);
        } else if (value >= 99.5) {
            setColor('#F3C827');
            // setIcon(faTemperatureHigh);
        } else if (value <= 95.0) {
            setColor('#870572');
            // setIcon(faTemperatureLow);
        } else if (value <= 97.7) {
            setColor('#008DF1');
            // setIcon(faTemperatureLow);
        } else {
            setColor('#06C317');
            // setIcon(faCheck);
        }
    }

    const valuetext = value => {
        return `${value}°F`;
    }

    const onChange = (event, value) => {
        setTemp(value);
        getTempColor(value);
    }
    
    return (
        <div className="d-flex justify-content-center">
            <div className="thermometer-container">
                <CustomSlider 
                    orientation="vertical"
                    step={0.1}
                    defaultValue={temp}
                    // value={temp}
                    max={110}
                    min={90}
                    getAriaValueText={valuetext}
                    className="thermometer-track"
                    onChangeCommitted={onChange}
                    valueLabelDisplay="on"
                />
                <div className="thermometer-bottom" style={{backgroundColor: color}}>

                </div>
            </div>
        </div>
    )
}

export default TEMP;